<template>
  <div class="main">
    <!-- 轮播图 -->
    <div class="home-banner"
         :style="{ backgroundImage: 'url(' + (tabs[tabIndex] && tabs[tabIndex].banner_image ? tabs[tabIndex].banner_image : require('../assets/images/banner.png')) + ')'}">
    </div>
    <div class="agent">
      <div class="box">

        <div class="u-flex u-row-center tab">
          <div class="item" :class="{ 'active': tabIndex === index }" v-for="(item, index) in tabs" :key="index"
               @click="onTab(index)">{{ item.name }}
          </div>
        </div>
        <!-- 商品分类特性 -->
        <div>
          <div
              v-if="tabs[tabIndex] && tabs[tabIndex].goods_category_features && tabs[tabIndex].goods_category_features.length > 0">
            <div class="u-flex ip" style="display: flex;justify-content: space-between;">
              <p v-for="(feature, index) in tabs[tabIndex].goods_category_features" :key="index">{{ feature.title }}</p>
            </div>
          </div>
        </div>
        <div>
          <div class=" list">
            <div class="item" v-for="(item, index) in dataSouce" :key="index">
              <div style="width: 90%;margin-left: 5%;padding: 1.5rem 0;">
                <!-- 定制套餐样式 -->
                <div v-if="item.price_type == 2">
                  <div>
                    <div class="name">{{ item.title }}</div>
                    <div class="money">￥量大从优</div>
                    <div class="old-money">原价：￥量大从优</div>
                  </div>
                  <ul>
                    <li class="u-flex u-row-between">
                      <em>会话时间</em>
                      <span>按需订制</span>
                    </li>
                    <li class="u-flex u-row-between">
                      <em>实到流量</em>
                      <span>按需订制</span>
                    </li>
                    <li class="u-flex u-row-between">
                      <em>IP数量</em>
                      <span>按需订制</span>
                    </li>
                    <li class="u-flex u-row-between">
                      <em>套餐有效期</em>
                      <span>按需订制</span>
                    </li>
                  </ul>
                  <el-button class="once-buy" type="primary" round @click="contactService(item)">联系客服</el-button>
                </div>

                <!-- 普通套餐样式 -->
                <div v-else>
                  <div style="display: flex;align-items: center;height:100px;justify-content: center">
                    <div v-if="item.discount>0"
                         style="background: #d5effe;border-radius: 50%;text-align: center;display: flex;align-items: center;justify-content: center;width: 4rem;height: 4rem">
                      {{ (item.discount / 100).toFixed(2) }}折
                    </div>
                    <div style="margin-left: 15px">
                      <div class="name">{{ item.title }}</div>
                      <div class="money">
                        ￥{{ (item.price - (item.price * item.discount / 100)).toFixed(2) }}
                      </div>
                      <div class="old-money" v-if="item.discount>0">原价：￥{{ item.price }}</div>
                    </div>
                  </div>
                  <div style="font-size: 12px;word-break: break-all;color: #8c939d;margin-top: 10px;min-height:50px">
                    {{ item.description }}
                  </div>
                  <ul>
                    <li class="u-flex u-row-between">
                      <em>实到流量</em>
                      <span>{{ item.internet_traffic == 0 ? '不限量' : item.internet_traffic + 'GB' }}</span>
                    </li>
                    <li class="u-flex u-row-between" v-if="item.broadband > 0">
                      <em>带宽</em>
                      <span>{{ item.broadband }}M</span>
                    </li>
                    <li class="u-flex u-row-between" v-if="item.broadband > 0">
                      <em>价格</em>
                      <span>{{ item.price }}元/月</span>
                    </li>

                    <li class="u-flex u-row-between" v-if="item.broadband == 0">
                      <em>单价</em>
                      <span>{{ item.internet_traffic_pirce }}元/G</span>
                    </li>

                  </ul>
                  <div style="height: 100px;text-align: center;line-height: 100px">
                    <el-button class="once-buy"  type="primary" round @click="createOrder(item)">立即购买</el-button>
                  </div>

                </div>
              </div>

            </div>

          </div>
        </div>


        <Dialog title="订单确认" width="500px" ref="confimeOrder" @confirm="confirmOrder">
          <div class="order-confirm-content">
            <div class="order-info">

              <div class="order-item" v-if="currentOrderItem">
                <div class="item-details">
                  <!--                  <span>会话时间：{{ currentOrderItem.validity_minutes }}分钟</span>-->
                  <span>套餐名称：{{

                      currentOrderItem.title
                    }}</span>
                  <span>实到流量：{{
                      currentOrderItem.internet_traffic == 0 ? '不限量' :
                          currentOrderItem.internet_traffic + 'GB'
                    }}</span>
                  <span v-if="currentOrderItem.broadband>0">
                    价格：{{
                      currentOrderItem.price + '元/月'
                    }}
                  </span>
                  <span v-if="currentOrderItem.broadband==0">流量单价：{{
                      currentOrderItem.internet_traffic_pirce + '元/GB'
                    }}</span>
                  <!--                  <span>IP数量：{{-->
                  <!--                      currentOrderItem.limitation_ip == 0 ? '不限量' : currentOrderItem.limitation_ip +-->
                  <!--                          '个'-->
                  <!--                    }}</span>-->
                  <!--                  <span-->
                  <!--                      v-if="currentOrderItem.gift > 0 && (currentOrderItem.limitation_ip * currentOrderItem.gift / 100) >= 1"-->
                  <!--                      class="gift-text"> + 赠送{{-->
                  <!--                      (currentOrderItem.limitation_ip * currentOrderItem.gift /-->
                  <!--                          100).toFixed(2)-->
                  <!--                    }}个</span>-->
                  <!--                  <span>套餐有效期：{{-->
                  <!--                      currentOrderItem.duration_days == 0 ? '永久' : currentOrderItem.duration_days +-->
                  <!--                          '天'-->
                  <!--                    }}</span>-->
                </div>
              </div>
            </div>

            <div class="payment-section">
              <h3>支付方式</h3>
              <div class="payment-options">
                <div v-for="option in payOptions" :key="option.type" class="payment-option"
                     :class="{ 'active': selectedPayType === option.type }" @click="selectPayType(option.type)">
                  <img :src="option.icon" :alt="option.name" class="payment-icon">
                  <span class="payment-name">{{ option.name }}</span>
                </div>
              </div>
            </div>

            <div class="order-amount">
              <div class="amount-label">订单金额</div>
              <div class="amount-value">¥{{ orderAmount }}</div>
            </div>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showOrderConfirmDialog = false">取消</el-button>
            <el-button type="primary" @click="confirmOrder">确认订单</el-button>
          </div>
        </Dialog>

        <Dialog title="微信支付" ref="wathcPay" width="400px">
          <div style="text-align: center;">
            <h3>微信扫码支付</h3>
            <div style="margin: 20px 0;">
              <img :src="wechatQrCode" alt="微信支付二维码"
                   style="max-width: 200px; height: auto; border: 1px solid #eee; border-radius: 4px;">
            </div>
            <p>请使用微信扫描二维码完成支付</p>
          </div>
          <div slot="btn" style="display: flex;align-items: center;justify-content: center;margin-top: 20px">
            <div>
              <el-button @click="$refs.wathcPay.onClose()">取消</el-button>
              <el-button type="success" @click="goPayStatus">查看支付状态</el-button>
            </div>

          </div>
        </Dialog>

        <Dialog title="支付宝支付" ref="aliPay" width="400px">
          <div style="text-align: center;">
            <div style="margin: 20px 0;">
              <div style="margin: 20px 0;">
                <img src="../assets/images/gmdl_zhifubao.png"/>
              </div>
            </div>
            <p>请点击下方按钮跳转到支付宝完成支付</p>

          </div>
          <div slot="btn" style="display: flex;align-items: center;justify-content: center;margin-top: 20px">
            <el-button @click="$refs.aliPay.onClose()">取消</el-button>
            <el-button type="success" @click="goPayStatus">查看支付状态</el-button>
            <el-button type="primary" @click="goToAlipayPay">去支付</el-button>
          </div>
        </Dialog>

        <Dialog title="余额支付" ref="balance" width="400px">
          <div style="text-align: center;">
            <div style="margin: 20px 0;">
              <img src="../assets/images/balance.png"/>
            </div>
            <p style="color: #ff6b35; font-weight: bold;">支付金额：¥{{ orderAmount }}</p>
          </div>
          <div slot="btn" style="display: flex;align-items: center;justify-content: center;margin-top: 20px">
            <el-button @click="$refs.balance.onClose()">取消</el-button>
            <el-button type="primary" @click="onOrderPay" :loading="payLoadint">确定</el-button>
          </div>
        </Dialog>

      </div>
    </div>

    <section class="features">
      <div>
        <h2>给你最好的工作流程和体验</h2>
        <p>值得信赖的专业化代理平台，提高效率，降低成本，您的私人专属代理</p>
        <div class="feature-cards"
             v-if="tabs[tabIndex] && tabs[tabIndex].goods_category_service && tabs[tabIndex].goods_category_service.length > 0">
          <div class="feature-card" v-for="(feature, index) in tabs[tabIndex].goods_category_service" :key="index">
            <img :src="feature.image || require('../assets/images/gmdl_icon' + (index + 1) + '.png')"
                 :alt="feature.title">
            <h3>{{ feature.title }}</h3>
            <p>{{ feature.description }}</p>
          </div>
        </div>
        <!-- 默认特性卡片，当没有商品服务时显示 -->
        <div class="feature-cards" v-else>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon6.png" alt="每日30万高匿IP">
            <h3>每日30万高匿IP</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon5.png" alt="单次提取数量自定义">
            <h3>单次提取数量自定义</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon1.png" alt="延迟小于100毫秒">
            <h3>延迟小于100毫秒</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon3.png" alt="日提取数量不限">
            <h3>日提取数量不限</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon2.png" alt="可拓展API接口">
            <h3>可拓展API接口</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
          <div class="feature-card">
            <img src="../assets/images/gmdl_icon4.png" alt="7X24小时技术服务支持">
            <h3>7X24小时技术服务支持</h3>
            <p>每天可获取的IP量超200万<br/>覆盖全国大部分省市</p>
          </div>
        </div>
      </div>
    </section>
  </div>

</template>

<script>
import Pay from './Pay.vue'
import Dialog from "@/components/Dialog.vue";

export default {
  name: 'AbroadIpGoods',
  components: {
    Dialog,
  },
  data() {
    return {
      tabIndex: 0,
      tabs: [],
      dataSouce: [],
      // 订单确认弹层相关数据
      showOrderConfirmDialog: false,
      currentOrderItem: null,
      orderAmount: '0.00',
      selectedPayType: 'balance',
      payOptions: [
        {name: '余额', icon: require('../assets/images/balance.png'), type: 'balance'},
        {name: '支付宝', icon: require('../assets/images/gmdl_zhifubao.png'), type: 'alipay'},
        // {name: '微信', icon: require('../assets/images/gmdl_weixin.png'), type: 'wechat'}
      ],

      // 支付相关数据
      order_sn: '',

      // 微信支付相关
      showWechatDialog: false,
      wechatPayData: null,
      wechatQrCode: '',

      // 支付宝支付相关
      showAlipayDialog: false,
      alipayPayData: null,

      // 余额支付相关
      showBalanceDialog: false,
      balancePayData: null,
      payLoadint: false,
    }
  },
  created() {
    this.getAbriadIpGoodsCategory()
  },
  mounted() {
    // 确保在组件挂载后初始化
    if (this.tabs.length > 0) {
      this.tabIndex = 0
      this.getAbriadIpGoods(this.tabs[0].id)
    }
  },

  methods: {
    handleAction(product) {
      if (product.isCustom) {
        // 联系客服逻辑
        console.log('联系客服')
      } else {
        // 立即购买逻辑
        console.log('立即购买', product)
      }
    },
    getAbriadIpGoodsCategory() {
      this.$api.goods.getAbriadIpGoodsCategory().then(res => {
        this.tabs = res.data
        if (this.tabs.length > 0) {
          this.tabIndex = 0
          this.getAbriadIpGoods(this.tabs[0].id)
        }
      })
    },
    getAbriadIpGoods(category_id) {
      this.$api.goods.getAbriadIpGoods({
        category_id: category_id
      }).then(res => {
        this.dataSouce = res.data.data
      })
    },
    onTab(index) {
      this.tabIndex = index
      if (this.tabs[index] && this.tabs[index].id) {
        this.getAbriadIpGoods(this.tabs[index].id)
      }
    },
    createOrder(item) {
      // 设置订单确认弹层数据
      this.currentOrderItem = item;
      this.orderAmount = (item.price - (item.price * item.discount / 100)).toFixed(2);
      this.$refs.confimeOrder.onOpen()
    },
    onPaySuccess(payResult) {
      // 支付成功后的处理
      console.log('支付成功:', payResult)
      this.$message.success('购买成功！')
      // 可以在这里刷新商品列表或其他操作
      // this.getAbriadIpGoods(this.tabs[this.tabIndex].id)
    },

    // 确认订单并创建
    confirmOrder() {


      if (!this.currentOrderItem) {
        this.$message.error('订单信息不完整');
        return;
      }

      // 创建订单
      this.$api.order.createOrder({
        goods_id: this.currentOrderItem.id,
        pay_type: this.selectedPayType
      }).then(res => {
        this.order_sn = res.data.orderInfo.order_sn;
        if (this.selectedPayType == 'balance') {
          // 余额支付，显示弹窗
          this.$refs.balance.onOpen()
        } else if (this.selectedPayType == 'wechat') {
          this.onOrderPay();
        } else if (this.selectedPayType == 'alipay') {
          // 支付宝支付，显示弹窗
          this.onOrderPay();
        }
        this.showOrderConfirmDialog = false;
      })
    },

    // 选择支付方式
    selectPayType(type) {
      this.selectedPayType = type;
    },

    // 支付处理
    onOrderPay() {
      this.payLoadint = true
      this.$api.order.orderPay({paytype: this.selectedPayType, order_sn: this.order_sn}).then(res => {
        if (res.data.paytype == 'balance') {
          this.$message.success('支付成功');
          this.$refs.balance.onClose();
        } else if (res.data.paytype == 'wechat') {
          this.showWechatPayDialog(res.data);
        } else if (res.data.paytype == 'alipay') {
          this.showAlipayPayDialog(res.data);
        }
      }).finally(() => {
        this.payLoadint = false
      })
    },

    // 显示微信支付弹窗
    showWechatPayDialog(payData) {
      // 获取二维码数据，支持多种字段名和base64格式
      let qrCodeData = payData.wechat_data || payData.qr_code || payData.qrcode || payData.qrCode || ''

      // 如果是base64格式，需要添加data:image前缀
      if (qrCodeData && !qrCodeData.startsWith('data:image') && !qrCodeData.startsWith('http')) {
        // 假设返回的是纯base64数据，添加图片前缀
        qrCodeData = `data:image/png;base64,${qrCodeData}`
      }

      // 设置微信支付弹窗数据
      this.wechatPayData = payData;
      this.wechatQrCode = qrCodeData;
      this.$refs.wathcPay.onOpen()
    },

    // 显示支付宝支付弹窗
    showAlipayPayDialog(payData) {
      // 设置支付宝支付弹窗数据
      this.alipayPayData = payData;
      this.$refs.aliPay.onOpen()
    },

    // 支付宝支付弹窗按钮处理方法
    goToAlipayPay() {
      this.redirectToAlipay(this.alipayPayData);
    },

    // 查看支付状态
    goPayStatus() {
      this.$router.push({
        path: '/pay-status',
        query: {order_sn: this.order_sn, type: 'orderpay'}
      });
    },

    // 跳转到支付宝支付
    redirectToAlipay(payData) {
      if (payData.alipay_data) {
        // 如果有HTML内容，打开新窗口
        const newWindow = window.open()
        newWindow.document.write(payData.alipay_data)
        newWindow.document.close()
      } else if (payData.redirect_url) {
        // 如果有重定向URL，直接跳转
        window.location.href = payData.redirect_url
      } else {
        this.$message.error('支付宝支付链接获取失败')
      }
    },

    // 联系客服
    contactService(item) {
      this.$message.info('正在为您转接客服，请稍候...');
      // 这里可以添加联系客服的逻辑，比如打开客服聊天窗口或跳转到客服页面
      // 例如：window.open('客服链接', '_blank');
    },


  }
}
</script>

<style scoped>
.main {
  margin: auto 0;
  background-color: #f7f8fa;
  margin-top: 80px;
}

/* banner */
.home-banner {
  width: auto;
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 300px;;
}

.agent {
  width: 100%;
}

.box {
  width: 80%;
  background: #fff;
  padding: 50px;
  margin: 0 auto;
  margin-top: 20px;

}


.tab .item {
  width: 168px;
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  text-align: center;
  border-radius: 4px;
}


.tab .active {
  color: #fff;
  background: #2682ff;
}


.combo h3 {
  width: 100%;
  display: block;
  font-size: 16px;
}

.combo h3:nth-of-type(2) {
  padding-top: 10px;
  border-top: 1px solid #ccc;
}


.custom-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}


.collapse dl {
  height: 36px;
  line-height: 36px;
  font-size: 12px;
}

.collapse dl dd {
  padding: 0 10px;
  height: 20px;
  line-height: 20px;
  color: #f27729;
  font-size: 12px;
  background: #fde4dd;
  border-radius: 4px;
}


.ip-effect button {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 15px;
  cursor: pointer;
  margin-right: 10px;
  border-radius: 4px;
}

.ip-effect button.active {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}


.purchase h3 {
  color: #183e7c;
  font-size: 16px;
  font-weight: 600;
}


.charge ::v-deep.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #143b72;
  background: #e9efff;
  border: 1px solid #2780fe;
}

.charge h4 {
  font-size: 16px;
}

.charge span {
  padding: 2px 10px;
  color: #143b72;
  font-size: 12px;
  border-radius: 2px;
  background: #fbf0ea;
}

.charge p {
  color: #46678a;
  font-size: 14px;
}


.total em {
  color: #f3753b;
}

.product-features li {
  width: 34%;
  height: 40px;
  line-height: 40px;
  color: #183e7c;
  font-size: 14px;
}


.order {
  margin-left: 50px;
  /* padding: 0 50px; */
  width: 280px;
}

.order h3 {
  color: #183e7c;
  font-size: 16px;
  font-weight: 600;
}

.order dl {
  height: 50px;
  line-height: 50px;
  color: #143b72;
  font-size: 14px;
}

.order dl dt {
  font-weight: 500;
}

.pay {
  border-top: 1px solid #eee;
}

.pay dt {
  color: #f3753b;
  font-size: 20px;
}

.payment {
  margin-top: 20px;
  display: flex;
}

.payment ::v-deep.el-radio-button {
  width: 100%;
  box-sizing: border-box;
}

.payment ::v-deep.el-radio-button__inner {
  padding: 8px 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
}

.payment ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #1a336b;
  background: #e9efff;
}

.pay-type {
  color: #1a336b;
}

.payment-options button {
  background: none;
  border: 1px solid #ddd;
  padding: 8px 15px;
  cursor: pointer;
  margin-right: 10px;
  border-radius: 4px;
}


.ip {
  width: 100%;
  padding: 3rem 0;
  /* height: 92px; */
  /* line-height: 92px; */
}

.ip p {
  /* width: 20%; */
  color: #183e7c;
  font-size: 14px;

}

.ip p::before {
  margin-right: 10px;
  content: "";
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background: #1ae206;
}

.list .item {
  position: relative;
  width: 100%;
  /* padding: 30px 10%; */
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #fff;
  box-shadow: 0 2px 14px 2px #e0e0e0;

}

.list .item:hover {
  border: 1px solid #1976d2;
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.2);
}

.list .name {
  width: 100%;
  color: #2682ff;
  font-size: 20px;
  text-align: center;
}

.list .money {
  padding: 4px 0;
  width: 100%;
  color: #ff7319;
  font-size: 16px;
  text-align: center;
}

.list .old-money {
  width: 100%;
  color: #999;
  font-size: 16px;
  text-align: center;
  text-decoration: line-through;
}

.list .item:nth-of-type(4n) {
  margin-right: 0;
}

.list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 30px;
}

/* 响应式布局 */
@media (max-width: 1200px) {
  .list .item {
    width: calc(33.333% - 15px);
    min-width: 250px;
  }
}

@media (max-width: 900px) {
  .list .item {
    width: calc(50% - 15px);
    min-width: 200px;
  }
}

@media (max-width: 600px) {
  .list .item {
    width: 100%;
    min-width: auto;
  }
}


.package-header .name {
  color: #1976d2;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
}


.package-details li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
  font-size: 14px;
}

.package-details li:last-child {
  border-bottom: none;
}

.package-details li em {
  color: #666;
  font-size: 14px;
  text-align: left;
}

.package-details li span {
  color: #666;
  font-size: 14px;
  text-align: right;
}

.list ul {
  margin-top: 56px;
}

.list li {
  height: 36px;
  line-height: 36px;
  color: #999;
  font-size: 14px;
}

.discount {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #000;
  font-size: 16px;
  text-align: center;
  border-radius: 50%;
  background: #d5effe;
  z-index: 1;
}

.normal-package .once-buy {
  margin-top: auto;
  width: 100%;
  color: #2682ff;
  background: none;
  border: 1px solid #2682ff;
}

.once-buy {
  margin-top: 20px;
  width: 100%;
  color: #2682ff;
  background: none;
  border: 1px solid #2682ff;
}

.list .item:hover .once-buy {
  color: #fff;
  background: #2682ff;

}


.order-item {
  padding: 5px;
}

.item-name {
  color: #2682ff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.item-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-details span {
  color: #666;
  font-size: 14px;
}

.payment-section {
  margin-bottom: 30px;
}

.payment-section h3 {
  color: #183e7c;
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
}

.payment-options {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.payment-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: white;
}

.payment-option:hover {
  border-color: #2682ff;
  background: #f8f9ff;
}

.payment-option.active {
  border-color: #2682ff;
  background: #e9efff;
}

.payment-icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.payment-name {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.order-amount {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.amount-label {
  color: #666;
  font-size: 16px;
  font-weight: 500;
}

.amount-value {
  color: #ff6b35;
  font-size: 24px;
  font-weight: 700;
}

/* 特性区域 */
.features {
  padding: 100px 0;
  text-align: center;
  background: #edf2f8;
}


.features h2 {
  font-size: 24px;
  margin-bottom: 4px;
}

.features p {
  margin-bottom: 10px;
  color: #999;
  font-size: 14px;
}

.feature-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.feature-card {
  margin-right: 10px;
  padding: 20px;
  flex: 0 0 calc(33.33% - 20px);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
}

.feature-card img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.feature-card h3 {
  font-size: 18px;
}

.feature-card p {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}

.customize p {
  line-height: 36px;
  color: #183e7c;
  font-size: 18px
}
</style>
